import React from 'react';
import { Fade } from 'react-awesome-reveal';
import './TimelineOverview.css';

const TimelineOverview = () => {
  const timelineItems = [
    {
      phase: 'DESIGN',
      title: 'Initial consultation',
      description: 'Understanding your vision, requirements, and space constraints through comprehensive consultation.',
      icon: 'fa fa-lightbulb',
      color: '#628141'
    },
    {
      phase: 'PLAN',
      title: 'Detailed proposal',
      description: 'Creating comprehensive design plans, 3D visualizations, and detailed project proposals.',
      icon: 'fa fa-file-alt',
      color: '#0aa514'
    },
    {
      phase: 'EXECUTE',
      title: 'Implementation phase',
      description: 'Expert execution of design with quality materials, skilled craftsmanship, and project management.',
      icon: 'fa fa-cog',
      color: '#628141'
    },
    {
      phase: 'REVIEW',
      title: 'Quality assessment',
      description: 'Thorough quality checks and reviews to ensure everything meets our high standards.',
      icon: 'fa fa-check-circle',
      color: '#0aa514'
    },
    {
      phase: 'COMPLETE',
      title: 'Final walkthrough',
      description: 'Final inspection and handover, ensuring complete satisfaction with your transformed space.',
      icon: 'fa fa-flag-checkered',
      color: '#628141'
    }
  ];

  return (
    <div className="timeline-overview-section container-xxl py-6">
      <div className="container">
        <Fade direction="down" triggerOnce>
          <div className="text-center mb-5">
            <p className="text-primarys text-uppercase mb-2">// Process Overview</p>
            <h1 className="display-6 mb-4">Our Project Timeline</h1>
            <p className="lead mb-0">
              From initial consultation to final delivery, we guide you through every step
            </p>
          </div>
        </Fade>

        <div className="timeline-container">
          {timelineItems.map((item, index) => (
            <Fade
              key={index}
              direction={index % 2 === 0 ? 'left' : 'right'}
              delay={index * 150}
              triggerOnce
            >
              <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
                <div className="timeline-content">
                  <div className="timeline-card">
                    <div className="timeline-icon-wrapper">
                      <div 
                        className="timeline-icon"
                        style={{ backgroundColor: item.color }}
                      >
                        <i className={item.icon}></i>
                      </div>
                    </div>
                    <div className="timeline-body">
                      <div className="timeline-phase">{item.phase}</div>
                      <h4 className="timeline-title">{item.title}</h4>
                      <p className="timeline-description">{item.description}</p>
                    </div>
                  </div>
                </div>
                <div 
                  className="timeline-marker"
                  style={{ backgroundColor: item.color }}
                >
                  <span className="timeline-number">{index + 1}</span>
                </div>
              </div>
            </Fade>
          ))}
          <div className="timeline-line"></div>
        </div>
      </div>
    </div>
  );
};

export default TimelineOverview;


